function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "TasksNavigationHoverBG"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_132",
  className: "backgroundOuter",
  "data-name": "Ellipse 132",
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#0f426e"
}), /*#__PURE__*/React.createElement("g", {
  id: "TasksNavigationHover",
  transform: "translate(18.5 17.5)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_61",
  className: "backgroundInner",
  "data-name": "Ellipse 61",
  cx: 13.5,
  cy: 13.5,
  r: 13.5,
  transform: "translate(0 1)",
  fill: "#f2f7fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "exclamation_mark",
  className: "exclamationMark",
  fill: "#002d56",
  transform: "translate(11 1)",
  d: "M2.62 15.66c-.627 0-.973-.367-1.04-1.1L.94 7.72c-.067-.587.05-1.067.35-1.44s.743-.56 1.33-.56c.573 0 1.007.187 1.3.56.293.373.407.853.34 1.44l-.64 6.84c-.08.733-.413 1.1-1 1.1zm0 4.44c-.533 0-.957-.16-1.27-.48-.313-.32-.47-.733-.47-1.24 0-.493.157-.897.47-1.21.313-.313.737-.47 1.27-.47s.95.157 1.25.47c.3.313.45.717.45 1.21 0 .507-.15.92-.45 1.24-.3.32-.717.48-1.25.48z"
})));

function SvgTaskRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskRound);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij4KICA8ZyBpZD0iVGFza3NOYXZpZ2F0aW9uSG92ZXJCRyI+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzEzMiIgY2xhc3M9ImJhY2tncm91bmRPdXRlciIgZGF0YS1uYW1lPSJFbGxpcHNlIDEzMiIgY3g9IjMyIiBjeT0iMzIiIHI9IjMyIiBmaWxsPSIjMGY0MjZlIi8+CiAgICA8ZyBpZD0iVGFza3NOYXZpZ2F0aW9uSG92ZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4LjUgMTcuNSkiPgogICAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzYxIiBjbGFzcz0iYmFja2dyb3VuZElubmVyIiBkYXRhLW5hbWU9IkVsbGlwc2UgNjEiIGN4PSIxMy41IiBjeT0iMTMuNSIgcj0iMTMuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0iI2YyZjdmYSIvPgogICAgICA8cGF0aCBpZD0iZXhjbGFtYXRpb25fbWFyayIgY2xhc3M9ImV4Y2xhbWF0aW9uTWFyayIgZmlsbD0iIzAwMmQ1NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEsIDEpIiBkPSJNMi42MiwxNS42NiBDMS45OTMzMzAyLDE1LjY2IDEuNjQ2NjY3LDE1LjI5MzMzNyAxLjU4LDE0LjU2IEwwLjk0LDcuNzIgQzAuODczMzMzLDcuMTMzMzMwNCAwLjk4OTk5ODUsNi42NTMzMzUyIDEuMjksNi4yOCBDMS41OTAwMDE1LDUuOTA2NjY0OCAyLjAzMzMzMDQsNS43MiAyLjYyLDUuNzIgQzMuMTkzMzM2Miw1LjcyIDMuNjI2NjY1Miw1LjkwNjY2NDggMy45Miw2LjI4IEM0LjIxMzMzNDgsNi42NTMzMzUyIDQuMzI2NjY3LDcuMTMzMzMwNCA0LjI2LDcuNzIgTDMuNjIsMTQuNTYgQzMuNTM5OTk5NiwxNS4yOTMzMzcgMy4yMDY2Njk2LDE1LjY2IDIuNjIsMTUuNjYgWiBNMi42MiwyMC4xIEMyLjA4NjY2NCwyMC4xIDEuNjYzMzM0OSwxOS45NDAwMDE2IDEuMzUsMTkuNjIgQzEuMDM2NjY1MSwxOS4yOTk5OTg0IDAuODgsMTguODg2NjY5MiAwLjg4LDE4LjM4IEMwLjg4LDE3Ljg4NjY2NDIgMS4wMzY2NjUxLDE3LjQ4MzMzNDkgMS4zNSwxNy4xNyBDMS42NjMzMzQ5LDE2Ljg1NjY2NTEgMi4wODY2NjQsMTYuNyAyLjYyLDE2LjcgQzMuMTUzMzM2LDE2LjcgMy41Njk5OTg1LDE2Ljg1NjY2NTEgMy44NywxNy4xNyBDNC4xNzAwMDE1LDE3LjQ4MzMzNDkgNC4zMiwxNy44ODY2NjQyIDQuMzIsMTguMzggQzQuMzIsMTguODg2NjY5MiA0LjE3MDAwMTUsMTkuMjk5OTk4NCAzLjg3LDE5LjYyIEMzLjU2OTk5ODUsMTkuOTQwMDAxNiAzLjE1MzMzNiwyMC4xIDIuNjIsMjAuMSBaIiAvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };